import Vue from 'vue'
import isClosestNode from 'www/utils/is/isClosestNode'
import AppCalendarButton from 'www/vue_components/common/AppointmentCalendar/components/AppCalendarButton/AppCalendarButton.vue'
import AppointmentButtonCallLpu from 'www/vue_components/common/AppointmentButtonCallLpu/AppointmentButtonCallLpu.vue'
import { NAMESPACE } from 'www/modules/Schedule/classes/ScheduleData/constants'
import getInitialDay from 'www/modules/Schedule/classes/ScheduleData/functions/renderData/helpers/getInitialDay'

/**
 * @description
 * Возвращает объект Map, который используется дальше для рендера календарей(календари с выбором специальности).
 * Функция возвращает список, который состоит из множества объектов рендера, или же только из одного.
 * При спецразмещении может быть несколько дубликатов карточек клиник. Сопоставление переменной 'isSingleRender' точно сообщает - в каком контейнере произошло изменение.
 * Если при клике передан parentCard и не найдено сопоставление - будет ошибка, которая ловится в вызывающем модуле.
 *
 * @param {object} opts -
 * @param {object} opts.data - собранные данные со страницы - интерфейс 'getModuleDataInterface'
 * @param { HTMLElement } opts.parentCard - карточка в списке, в которой необходимо заменить расписание
 * @param {Array<object>} opts.response - ответ на запрос
 * @param {string} opts.dataItem - data атрибут родителя
 *
 * @returns { Map } - данные для рендера списка календарей
 */

const getRenderLpuData = opts => {
  const {
    data,
    response,
    dataItem,
    parentCard,
  } = opts
  const resultData = new Map()

  data.items.forEach((pageData, scheduleContainer) => {
    const {
      lpuId,
      lpuPhone,
      coverNode,
      doctorsLpuHref,
      appointmentType,
      lpuWorkingText,
    } = pageData
    const scheduleData = response.find(({ lpu_id: idResult }) => idResult === lpuId)
    const isListRender = !parentCard // рендер списка календарей
    const isSingleRender = parentCard === coverNode // рендер только 1 календаря

    if (!scheduleData) {
      if (
        window.MOBILE_VERSION
        && appointmentType === 'express'
        && lpuPhone
      ) {
        scheduleContainer.innerHTML = '<div class="schedule-button"></div>'

        new Vue({
          el: scheduleContainer.querySelector('.schedule-button'),
          render: h => h(AppointmentButtonCallLpu, {
            props: {
              phone: lpuPhone,
              lpuWorkingText,
            },
          }),
        })

        return
      }

      if (isClosestNode(scheduleContainer, parentCard)) {
        renderAppointmentButton({
          doctorsLpuHref,
          scheduleContainer,
        })
      }

      return
    }

    if (coverNode) {
      const lpuNotWorkingNode = coverNode.querySelector('.vue-mount-lpu-not-working-label')

      if (lpuNotWorkingNode && scheduleData.appointment_type === 'express') {
        lpuNotWorkingNode.classList.remove('d-none')
      } else if (lpuNotWorkingNode && scheduleData.appointment_type === 'direct') {
        lpuNotWorkingNode.classList.add('d-none')
      }
    }

    if (!(isListRender || isSingleRender)) {
      return
    }

    const { slots } = scheduleData
    const days = Object.keys(slots)
    const daysWithSlots = days.filter(date => slots[date].length)
    const specialtyId = coverNode // ToDo schedule-important избавиться от привязки к DOM дереву
      .querySelector(`[${NAMESPACE.dataSelectedSpecialityId}]`)
      .getAttribute(NAMESPACE.dataSelectedSpecialityId)

    const initDay = getInitialDay({
      daysWithSlots,
      currentSlots: slots,
    })

    resultData.set(scheduleContainer, {
      days,
      slots,
      lpuId,
      initDay,
      dataItem,
      lpuWorkingText,
      doctorsLpuHref,
      appointmentType: scheduleData.appointment_type || appointmentType,
      data: slots,
      options: slots,
      useRedirect: true,
      isAppointmentDoctor: true,
      doctorSpec: specialtyId,
      lpuPhone,
    })
  })

  return resultData
}

function renderAppointmentButton(
  {
    doctorsLpuHref,
    scheduleContainer,
  },
) {
  if (!doctorsLpuHref) {
    return
  }

  scheduleContainer.innerHTML = '<div class="schedule-button"></div>'

  new Vue({
    el: scheduleContainer.querySelector('.schedule-button'),
    render: h => h(AppCalendarButton, {
      props: {
        doctorHref: doctorsLpuHref,
      },
    }),
  })
}

export default getRenderLpuData
